import { render, staticRenderFns } from "./Permisos.vue?vue&type=template&id=acdbc7e0&scoped=true"
import script from "./Permisos.vue?vue&type=script&lang=js"
export * from "./Permisos.vue?vue&type=script&lang=js"
import style0 from "./Permisos.vue?vue&type=style&index=0&id=acdbc7e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdbc7e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acdbc7e0')) {
      api.createRecord('acdbc7e0', component.options)
    } else {
      api.reload('acdbc7e0', component.options)
    }
    module.hot.accept("./Permisos.vue?vue&type=template&id=acdbc7e0&scoped=true", function () {
      api.rerender('acdbc7e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/globals/permisos/Permisos.vue"
export default component.exports